import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../../helpers/spinner";
import helpersNumbers from "../../../../../helpers/numbers";
import helpersTime from "../../../../../helpers/time";
import StatusPledge from "../../StatusPledge";
import Pagination from "../../../../partials/content/Pagination";
import statusGiftRegisterUser from "./status";

export default function AllGiftUses() {
  const [giftUses, setGiftUses] = useState([]);
  const params = useParams();
  const giftID = params.giftID;

  useEffect(() => {
    getGiftUses();
  }, []);

  const getGiftUses = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetGiftUses = await sendRequestGetGiftUses();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestGetGiftUses) {
      return;
    }
    setGiftUses(resultSendRequestGetGiftUses);
  };

  const sendRequestGetGiftUses = async () => {
    let result;
    let headersRequest = getHeaderForRequest();
    try {
      result = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/gift-user-register/manage/gift-uses/${giftID}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return result.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateTable = () => {
    return (
      <div className="table-responsive">
        <table className="table table-hilite tbl-td-white-space">
          <thead>
            <tr>
              <td>شماره کاربر</td>
              <td>تاریخ استفاده</td>
            </tr>
          </thead>
          <tbody>
            {giftUses.map((item) => {
              return (
                <tr>
                  <td>
                    <span>{item.grui_user_id}</span>
                    <span className="pr-2">
                      <Link
                        className="btn btn-primary"
                        target="_blank"
                        to={`/user/show-info-user/${item.grui_user_id}`}
                      >
                        نمایش اطلاعات کاربر
                      </Link>
                    </span>
                  </td>
                  <td>
                    {helpersNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(
                        item.grui_created_at.split(" ")[0]
                      ) +
                        " " +
                        item.grui_created_at.split(" ")[1]
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>
      <Sidebar openItem="manage-finance" activeItem="gift-register-user" />
      <div className="content-wrapper">
        <section className="content-header pt-4 pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1 bg-warning">
                  لیست کاربران استفاده کننده از تخفیف
                </h1>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link
                  className="text-white"
                  to="/finance/manage/gift-register-user/all"
                >
                  <div className="btn btn-primary">
                    <span>
                      <span className="text-white">بازگشت</span>
                    </span>
                    <span className="pr-2">
                      <i className="fas fa-arrow-left" aria-hidden="true"></i>
                    </span>
                  </div>
                </Link>
              </div>
              {giftUses.length > 0 && generateTable()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
